<style src="./styles.scss" lang="scss"></style>
<template>
  <div class="SerproStatus wrapper wrapper-content animated fadeIn">
    <div class="row">
      <div class="mail-box">
        <div class="col-sm-2">
          <div class="form-group">
            <label class="col-md-12">Setor</label>
            <div class="col-md-12">
              <select class="form-control" v-model="searchForm.park">
                <option value="">Todos</option>
                <option
                  v-for="(item, idx) in parkingList"
                  :key="idx"
                  :value="item.id"
                >
                  {{ item.parkName }}
                </option>
              </select>
            </div>
          </div>
        </div>
        <div class="col-sm-2">
          <div class="form-group">
            <label class="col-md-12">Operador</label>
            <div class="col-md-12">
              <select class="form-control" v-model="searchForm.operator">
                <option value="">Todos</option>
                <option
                  v-for="(item, idx) in operators"
                  :key="idx"
                  :value="item.id"
                >
                  {{ item.name }}
                </option>
              </select>
            </div>
          </div>
        </div>
        <div class="col-sm-2">
          <div class="form-group">
            <label class="col-md-12">Cód. AIT</label>
            <input class="form-control" v-model="searchForm.aitCode" />
          </div>
        </div>
        <div class="col-sm-2">
          <div class="form-group">
            <label class="col-md-12">Cód. Crédito</label>
            <input class="form-control" v-model="searchForm.creditCode" />
          </div>
        </div>

        <div class="col-sm-1">
          <div class="form-group">
            <label class="col-md-12">De</label>
            <input type="date" v-model.lazy="searchForm.dateStart"/>
          </div>
        </div>
        <div class="col-sm-1">
          <div class="form-group">
            <label class="col-md-12">Até</label>
            <input type="date" v-model.lazy="searchForm.dateEnd"/>
          </div>
        </div>
      </div>
      <div class="col-sm-1">
        <div class="form-group">
          <button
            :disabled="isLoadingList"
            @click="() => listSendedRegisters(true)"
            type="submit"
            class="btn btn-block btn-primary compose-mail"
          >
            <i class="fa fa-search"></i>
            <i class="fa fa-spinner fa-spin" v-show="isLoadingList"></i>
          </button>
        </div>
      </div>
    </div>
    
    <div class="row">
      <div class="mail-box">
        <table class="table table-hover table-mail">
          <thead class="table-head">
            <tr>
              <!-- <th class="photo">Foto</th> -->
              <th class="createdAt" title="Data em que foi registrado a autuação no sistema">Data Aut.</th>
              <th class="createdAt" title="Data em que foi enviada para a SERPRO">Data Envio</th>
              <th class="code" title="Código do AIT">Cód. AIT</th>
              <th class="code" title="Código do sistema">Cód. Crédito</th>
              <th class="licencePlate" title="Placa">Placa</th>
              <th class="sector" title="Nome do Setor da ocorrência">Setor</th>
              <th class="amountPaid" title="Valor do ticket não pago">Ticket R$</th>
              <th class="amountPaid" title="Status da autuação no sistema">Status</th>
            </tr>
          </thead>

          <tbody class="table-list">
            <tr
              v-for="(item, itemIndex) in serpro.list"
              :key="itemIndex"
              @click="selectItem(itemIndex)"
            >
              <td>{{ DateBR(item.infractionDate) }}</td>
              <td>{{ DateBR(item.createdAt) }}</td>
              <td>{{ item.numeroAuto }}</td>
              <td>{{ item.creditCode }}</td>
              <td>{{ item.veiculoPlaca.toUpperCase() }}</td>
              <td>{{ item.localDescricao }}</td>
              <td>{{ totalToCurrencyBR(item.amountPaid) }}</td>
              <td>
                <span class="badge" :class="`badge${getStatusType(item.status)}`">
                  {{ Status(item.status) }}
                </span>
              </td>
            </tr>

            <tr
              v-if="serpro.list.length === 0"
            >
              <td colspan="6">
                Nenhum registro encontrado.
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <div
      class="btn-group paginatecontent"
      v-if="serpro.countPages > 0"
    >
      <button
        class="btn btn-light btn-sm paginatebutton"
        :disabled="hasPageLeft"
        @click="previousPage"
      >
        <i class="fa fa-arrow-left" />
      </button>
      <button
        class="btn btn-light btn-sm paginatebutton"
        :disabled="hasPageRight"
        @click="nextPage"
      >
        <i class="fa fa-arrow-right" />
      </button>
    </div>

    <ModalDetails
      :show="isDetailsModalVisible"
      @close-modal="closeDetailsModal"
      :item="selectedItem"
      ref="cmpModalDetails"
    />
  </div>
</template>
<script>
import ModalDetails from './modal-details/ModalDetails.vue';
import { toast } from '@/plugins/toast';

export default {
  components: {
    ModalDetails
  },
  data() {
    return {
      isLoadingList: false,
      isDetailsModalVisible: false,
      searchForm: {
        park: '',
        operator: '',
        aitCode: '',
        creditCode: '',
        dateStart: 0,
        dateEnd: 0,
        page: 0,
        limit: 30,
      },
      serpro: {
        countPages: 0,
        originalList: [],
        list: [],
      },
      parkingList: [],
      operators: [],
      selectedItem: {},
    };
  },
  mounted() {
    this.setInitialDate();
    this.listParkings();
    this.listOperators();
  },
  computed: {
    hasPageLeft() {
      return this.searchForm.page === 0;
    },
    hasPageRight() {
      return this.searchForm.page + this.searchForm.limit >= this.serpro.countPages;
    },
  },
  methods: {
    totalToCurrencyBR(value) {
      return (value / 100).toLocaleString('pt-BR', {
        minimumFractionDigits: 2,
      });
    },
    DateBR(dt) {
      return new Date(dt).toLocaleString('pt-br');
    },
    Status(status) {
      switch (status) {
        case 0:
          return 'PENDENTE';
        case 1:
          return 'ENVIADO';
        case 2:
          return 'ERRO';
      }
    },
    setInitialDate() {
      this.searchForm.dateStart = new Date().toISOString().substr(0, 10);
      this.searchForm.dateEnd = new Date().toISOString().substr(0, 10);
    },
    async listSendedRegisters(resetList = false) {
      if (!this.checkDateRange()) return;
      this.isLoadingList = true;

      if (resetList) {
        this.searchForm.page = 0;
      }

      const dateStart = new Date(this.searchForm.dateStart + 'T00:00:00');
      const dateEnd = new Date(this.searchForm.dateEnd + 'T23:59:59');

      const payload = {
        ...this.searchForm,
        dateStart,
        dateEnd,
      };

      try {
        const serproList = await this.$store.dispatch(
          'SERPRO/ListSendedToSerpro',
          payload,
        );

        this.serpro.list = serproList.registers;
        this.serpro.countPages = serproList.totalDocuments;
      } catch (error) {
        toast.error('Não foi possível listar as solicitações');
      } finally {
        this.isLoadingList = false;
      }
    },
    previousPage() {
      if (this.searchForm.page === 0) {
        return;
      }
      this.searchForm.page = this.searchForm.page - this.searchForm.limit;
      this.listSendedRegisters();
    },
    nextPage() {
      if (this.searchForm.page + this.searchForm.limit >= this.serpro.countPages) {
        return;
      }
      this.searchForm.page = this.searchForm.page + this.searchForm.limit;
      this.listSendedRegisters();
    },
    async listParkings() {
      const parkingListFull = await this.$store.dispatch('PARKING/GetParkList');
      const parkingList = parkingListFull.map(item => ({
        id: item._id,
        parkName: item.parkName,
      }));
      this.parkingList = parkingList;
    },
    async listOperators() {
      const users = await this.$store.dispatch('SERPRO/ListOperators');
      const operators = users.map(item => ({
        id: item._id,
        name: item.fullName,
      }));

      this.operators = operators;
    },
    setDate(dt) {
      const date = new Date(dt);
      return date;
    },
    checkDateRange() {
      const isRangeValid = this.setDate(this.searchForm.dateStart) <= this.setDate(this.searchForm.dateEnd);
      if (!isRangeValid)toast.error('A data de início deve ser menor ou igual a data final');
      return isRangeValid;
    },
    closeDetailsModal() {
      this.isDetailsModalVisible = false;
    },
    selectItem(item) {
      this.$refs.cmpModalDetails.loadDetails(this.serpro.list[item]);
      this.isDetailsModalVisible = true;
      this.selectedItemIndex = item;
    },
    getStatusType(status) {
      switch (status) {
        case 0:
          return '-success';
        case 1:
          return '-primary';
        case 2:
          return '-danger';
      }
    },
  },
};
</script>
